const common_message_en = {
    delete_msg_title: "Are you sure?",
    delete_msg_text: "Deleted data cannot be recovered."
}

export default common_message_en;